import { useEffect, useState } from "react";
import {
  getTimezonePreference,
  type TimezonePreference,
} from "@/lib/timezonePreference";

/**
 * Reactive hook for the current timezone preference. Refreshes on the
 * in-tab `timezone-preference-updated` event and the cross-tab
 * `storage` event so every audit surface stays in sync the moment an
 * admin changes the picker.
 */
export function useTimezonePreference(): TimezonePreference {
  const [pref, setPref] = useState<TimezonePreference>(() => getTimezonePreference());

  useEffect(() => {
    if (typeof window === "undefined") return;
    const refresh = () => setPref(getTimezonePreference());
    const onStorage = (e: StorageEvent) => {
      if (e.key === "smplify-timezone-preference:v1") refresh();
    };
    window.addEventListener("timezone-preference-updated", refresh);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener("timezone-preference-updated", refresh);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  return pref;
}
